import React from 'react';
import { useRecordContext, EditButton } from 'react-admin';

const ConditionalEditButton = ({ source, ...rest }) => {
  const record = useRecordContext();
  return record && record[source] ? <EditButton {...rest} label="" /> :null;
};

export default ConditionalEditButton; // decorate with redux-form's <Field>
